import { headers, parseJSON } from '../../apiUtils';
import { arrayIsNotEmpty } from '../../utils';

export function fetchTicketCountOverTimeBreakdownStats(pageBreakdown, fromDate, toDate, timePeriodicity, teamId, selectedFilters) {
    let path = `/api/teamsdashboard/ticket-count-by-time-by-breakdown?fromDate=${fromDate}&toDate=${toDate}&timePeriodicity=${timePeriodicity}`;
    if (arrayIsNotEmpty(selectedFilters)) {
        const newArray = selectedFilters.map(obj => {
            return {
                domainValueId: obj.id,
                domainValueName: obj.value,
                domainId: obj.domainId
            };
        });
        const stringifySelectedFilters = JSON.stringify(newArray);
        path += `&selectedFilters=${stringifySelectedFilters}`;
    }

    if (pageBreakdown) {
        path += `&breakdown=${pageBreakdown}`;
    }
    if (teamId) {
        path += `&teamId=${teamId}`;
    }
    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchResponseOverTimeBreakdownStats(pageBreakdown, fromDate, toDate, timePeriodicity, teamId, selectedFilters) {
    let path = `/api/teamsdashboard/response-breakdown-by-time?fromDate=${fromDate}&toDate=${toDate}&timePeriodicity=${timePeriodicity}`;
    if (arrayIsNotEmpty(selectedFilters)) {
        const newArray = selectedFilters.map(obj => {
            return {
                domainValueId: obj.id,
                domainValueName: obj.value,
                domainId: obj.domainId
            };
        });
        const stringifySelectedFilters = JSON.stringify(newArray);
        path += `&selectedFilters=${stringifySelectedFilters}`;
    }
    if (pageBreakdown) {
        path += `&breakdown=${pageBreakdown}`;
    }
    if (teamId) {
        path += `&teamId=${teamId}`;
    }
    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}
